import {Transcription} from "./Transcription";

export class TranscribeJob {

  static DONE: string = "DONE";
  static PROCESSING: string = "PROCESSING";
  static FAILED: string = "FAILED";
  static NOT_CONSUMED: string = "NOT_CONSUMED";

  id: string = "";
  estimatedProgress: number = 0;
  status: string = "";
  transcription: Transcription = null;

  static fromJson(json): TranscribeJob {
    if (!json){
      throw new Error("missing json");
    }

    const job = new TranscribeJob();
    job.id = json.id;
    job.estimatedProgress = json.estimate_progress;
    job.status = json.status;

    if(json.transcription) {
      job.transcription = Transcription.fromJson(json.transcription);
    }

    return job;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/shared/TranscribeJob.ts